module.exports = __webpack_public_path__ + "img/room-event-star_ar.aad70a12.png";